// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* pml = pointage-materiels-liste */

.pml-page {
  background: #f8f5f1;
  min-height: 100vh;
  padding-bottom: 40px;
}

/* ── Header subtitle ── */
.pml-subtitle {
  font-size: 0.82rem;
  color: #999;
  margin-top: 2px;
  font-weight: 500;
}
.pml-subtitle-count {
  font-weight: 700;
  color: #6d4e36;
}

/* ── Hero Search ── */
.pml-search-hero .input-group {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(109, 78, 54, 0.12);
  border: 2px solid rgba(109, 78, 54, 0.25);
}
.pml-search-icon {
  background: rgba(109, 78, 54, 0.08);
  border: none;
  color: #6d4e36;
  font-size: 1rem;
}
.pml-search-input {
  border: none;
  font-size: 1rem;
  padding: 0.6rem 0.9rem;
  box-shadow: none !important;
}
.pml-search-input:focus {
  outline: none;
  box-shadow: none !important;
}
.pml-search-hero .input-group:focus-within {
  border-color: #6d4e36;
  box-shadow: 0 2px 16px rgba(109, 78, 54, 0.2);
}

/* ── Filter card ── */
.pml-filter-card {
  border-radius: 14px;
  border: 1.5px solid rgba(109, 78, 54, 0.22) !important;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* ── Result badge ── */
.pml-result-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(109, 78, 54, 0.1);
  color: #6d4e36;
  font-weight: 700;
  font-size: 0.78rem;
  border-radius: 20px;
  padding: 4px 12px;
  white-space: nowrap;
}

/* ── Table wrap ── */
.pml-table-wrap {
  border-radius: 14px;
  border: 1.5px solid rgba(109, 78, 54, 0.18);
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}

.pml-table-wrap table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  white-space: nowrap;
  min-width: 1050px;
}

.pml-table-wrap thead th {
  padding: 10px 12px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6d4e36;
  background: #faf7f4;
  border-bottom: 2px solid rgba(109, 78, 54, 0.18);
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.pml-table-wrap thead th.no-sort {
  cursor: default;
}

.pml-table-wrap tbody td {
  padding: 9px 12px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(109, 78, 54, 0.07);
  color: #4e3929;
}

.pml-table-wrap tbody tr:hover td {
  background: rgba(109, 78, 54, 0.03) !important;
}

/* ── Row bloqué ── */
.pml-row-bloque td {
  opacity: 0.55;
}

/* ── Chantier chip ── */
.pml-chantier-chip {
  display: inline-block;
  background: rgba(109, 78, 54, 0.1);
  color: #6d4e36;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Matricule ── */
.pml-matricule-text {
  font-weight: 600;
  color: #3a2a1a;
}

/* ── Observation truncate ── */
.pml-obs-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 220px;
}

/* ── Gasoil/Essence positive ── */
.pml-fuel-positive {
  color: #e65100;
  font-weight: 700;
}

/* ── Heures positive ── */
.pml-hours-value {
  font-weight: 600;
  color: #1565c0;
}

/* ── Action buttons ── */
.pml-action-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  flex-shrink: 0;
}
.pml-more-btn::after {
  display: none !important;
}
.pml-action-menu {
  border-radius: 12px !important;
  border: 1.5px solid rgba(109, 78, 54, 0.2) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  min-width: 230px;
  padding: 6px !important;
}
.pml-action-menu .dropdown-item {
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background 0.12s;
}
.pml-action-menu .dropdown-item:hover {
  background: rgba(109, 78, 54, 0.08);
  color: #6d4e36;
}
.pml-action-menu .dropdown-item-text {
  padding: 4px 12px;
  font-size: 0.82rem;
  color: #555;
}
.pml-action-menu .dropdown-divider {
  margin: 4px 6px;
}
.pml-detail-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #aaa;
  padding: 6px 12px 2px;
  display: block;
}

/* ── Pagination ── */
.pml-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid rgba(109, 78, 54, 0.1);
  background: #faf7f4;
}
.pml-pag-btn {
  background: #fff;
  border: 1.5px solid rgba(109, 78, 54, 0.3);
  color: #6d4e36;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.12s;
}
.pml-pag-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.pml-pag-btn:not(:disabled):hover {
  background: rgba(109, 78, 54, 0.1);
}
.pml-pag-info {
  font-size: 0.82rem;
  color: #888;
}

/* ── Empty state ── */
.pml-empty-state {
  text-align: center;
  padding: 52px 0;
  color: #bbb;
}
.pml-empty-icon {
  font-size: 2.5rem;
  opacity: 0.25;
  display: block;
  margin: 0 auto 12px;
}

/* scrollbar */
.pml-table-wrap::-webkit-scrollbar {
  height: 8px;
}
.pml-table-wrap::-webkit-scrollbar-thumb {
  background: #c8b7a6;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pointageMaterielListe.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,sDAAsD;EACtD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gDAAgD;EAChD,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,qDAAqD;EACrD,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* pml = pointage-materiels-liste */\r\n\r\n.pml-page {\r\n  background: #f8f5f1;\r\n  min-height: 100vh;\r\n  padding-bottom: 40px;\r\n}\r\n\r\n/* ── Header subtitle ── */\r\n.pml-subtitle {\r\n  font-size: 0.82rem;\r\n  color: #999;\r\n  margin-top: 2px;\r\n  font-weight: 500;\r\n}\r\n.pml-subtitle-count {\r\n  font-weight: 700;\r\n  color: #6d4e36;\r\n}\r\n\r\n/* ── Hero Search ── */\r\n.pml-search-hero .input-group {\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 12px rgba(109, 78, 54, 0.12);\r\n  border: 2px solid rgba(109, 78, 54, 0.25);\r\n}\r\n.pml-search-icon {\r\n  background: rgba(109, 78, 54, 0.08);\r\n  border: none;\r\n  color: #6d4e36;\r\n  font-size: 1rem;\r\n}\r\n.pml-search-input {\r\n  border: none;\r\n  font-size: 1rem;\r\n  padding: 0.6rem 0.9rem;\r\n  box-shadow: none !important;\r\n}\r\n.pml-search-input:focus {\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n.pml-search-hero .input-group:focus-within {\r\n  border-color: #6d4e36;\r\n  box-shadow: 0 2px 16px rgba(109, 78, 54, 0.2);\r\n}\r\n\r\n/* ── Filter card ── */\r\n.pml-filter-card {\r\n  border-radius: 14px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.22) !important;\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n/* ── Result badge ── */\r\n.pml-result-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: rgba(109, 78, 54, 0.1);\r\n  color: #6d4e36;\r\n  font-weight: 700;\r\n  font-size: 0.78rem;\r\n  border-radius: 20px;\r\n  padding: 4px 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Table wrap ── */\r\n.pml-table-wrap {\r\n  border-radius: 14px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.18);\r\n  overflow: hidden;\r\n  background: #fff;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\r\n  overflow-x: auto;\r\n}\r\n\r\n.pml-table-wrap table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.85rem;\r\n  white-space: nowrap;\r\n  min-width: 1050px;\r\n}\r\n\r\n.pml-table-wrap thead th {\r\n  padding: 10px 12px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #6d4e36;\r\n  background: #faf7f4;\r\n  border-bottom: 2px solid rgba(109, 78, 54, 0.18);\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n.pml-table-wrap thead th.no-sort {\r\n  cursor: default;\r\n}\r\n\r\n.pml-table-wrap tbody td {\r\n  padding: 9px 12px;\r\n  vertical-align: middle;\r\n  border-bottom: 1px solid rgba(109, 78, 54, 0.07);\r\n  color: #4e3929;\r\n}\r\n\r\n.pml-table-wrap tbody tr:hover td {\r\n  background: rgba(109, 78, 54, 0.03) !important;\r\n}\r\n\r\n/* ── Row bloqué ── */\r\n.pml-row-bloque td {\r\n  opacity: 0.55;\r\n}\r\n\r\n/* ── Chantier chip ── */\r\n.pml-chantier-chip {\r\n  display: inline-block;\r\n  background: rgba(109, 78, 54, 0.1);\r\n  color: #6d4e36;\r\n  border-radius: 20px;\r\n  padding: 2px 10px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Matricule ── */\r\n.pml-matricule-text {\r\n  font-weight: 600;\r\n  color: #3a2a1a;\r\n}\r\n\r\n/* ── Observation truncate ── */\r\n.pml-obs-text {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  max-width: 220px;\r\n}\r\n\r\n/* ── Gasoil/Essence positive ── */\r\n.pml-fuel-positive {\r\n  color: #e65100;\r\n  font-weight: 700;\r\n}\r\n\r\n/* ── Heures positive ── */\r\n.pml-hours-value {\r\n  font-weight: 600;\r\n  color: #1565c0;\r\n}\r\n\r\n/* ── Action buttons ── */\r\n.pml-action-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  display: inline-flex !important;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px !important;\r\n  flex-shrink: 0;\r\n}\r\n.pml-more-btn::after {\r\n  display: none !important;\r\n}\r\n.pml-action-menu {\r\n  border-radius: 12px !important;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.2) !important;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;\r\n  min-width: 230px;\r\n  padding: 6px !important;\r\n}\r\n.pml-action-menu .dropdown-item {\r\n  border-radius: 8px;\r\n  padding: 7px 12px;\r\n  font-size: 0.88rem;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background 0.12s;\r\n}\r\n.pml-action-menu .dropdown-item:hover {\r\n  background: rgba(109, 78, 54, 0.08);\r\n  color: #6d4e36;\r\n}\r\n.pml-action-menu .dropdown-item-text {\r\n  padding: 4px 12px;\r\n  font-size: 0.82rem;\r\n  color: #555;\r\n}\r\n.pml-action-menu .dropdown-divider {\r\n  margin: 4px 6px;\r\n}\r\n.pml-detail-label {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #aaa;\r\n  padding: 6px 12px 2px;\r\n  display: block;\r\n}\r\n\r\n/* ── Pagination ── */\r\n.pml-pagination-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  border-top: 1px solid rgba(109, 78, 54, 0.1);\r\n  background: #faf7f4;\r\n}\r\n.pml-pag-btn {\r\n  background: #fff;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.3);\r\n  color: #6d4e36;\r\n  border-radius: 8px;\r\n  width: 32px;\r\n  height: 32px;\r\n  font-size: 1.1rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.12s;\r\n}\r\n.pml-pag-btn:disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.pml-pag-btn:not(:disabled):hover {\r\n  background: rgba(109, 78, 54, 0.1);\r\n}\r\n.pml-pag-info {\r\n  font-size: 0.82rem;\r\n  color: #888;\r\n}\r\n\r\n/* ── Empty state ── */\r\n.pml-empty-state {\r\n  text-align: center;\r\n  padding: 52px 0;\r\n  color: #bbb;\r\n}\r\n.pml-empty-icon {\r\n  font-size: 2.5rem;\r\n  opacity: 0.25;\r\n  display: block;\r\n  margin: 0 auto 12px;\r\n}\r\n\r\n/* scrollbar */\r\n.pml-table-wrap::-webkit-scrollbar {\r\n  height: 8px;\r\n}\r\n.pml-table-wrap::-webkit-scrollbar-thumb {\r\n  background: #c8b7a6;\r\n  border-radius: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
